
export const CategoryApi = {
  getById: (axios, categoryId) => {
    return axios.$get('/api/category/' + categoryId);
  },
  getAll: (axios) => {
    return axios.$get('/api/categories');
  }
};
